import {
  SearchIndexDefinitionRepr,
  SearchIndexDefinitionJSON,
} from '../../../../../catalog/searchindex/representations';
import { fetchBody } from '../../../../../../util/service';
import { RequestParamLimit, RequestParamStart } from '../../../../../sonder/rest/paging';
import {
  Collection,
  CollectionMediaTypeJSON,
} from '../../../../../sonder/rest/representations/commons/commons';
import {
  FacetRepr,
  SearchFacetDefinitionJSON,
} from '../../../../../catalog/search/representations';
import { SearchSuggestionsRequest } from '../../../../grpc_web_catalog/catalog.pb';

export const GO_MAX_INT32 = 2147483647;

// 587
// GetSearchIndices - gets all search indices available in catalog
export const GetSearchIndices = async (): Promise<Collection<SearchIndexDefinitionRepr>> => {
  const response = await fetchBody({
    method: 'GET',
    url: '/catalog/search/indices',
    params: {
      [RequestParamStart]: 0,
      [RequestParamLimit]: GO_MAX_INT32,
    },
    headers: {
      Accept: CollectionMediaTypeJSON,
      'Accept-Item': SearchIndexDefinitionJSON,
    },
  });

  const collection = response as Collection<SearchIndexDefinitionRepr>;
  return collection;
};

// GetSearchSuggestions - gets type ahead search suggestions for items available in catalog
export const GetSearchSuggestions = async (
  req: SearchSuggestionsRequest
): Promise<Collection<string>> => {
  const params: any = {
    field: req.facet,
    [RequestParamStart]: 0,
    [RequestParamLimit]: req.limit,
    filterReferences: 'true',
  };
  if (req.value !== '') {
    params.q = req.value;
  }
  if (req.indices.length > 0) {
    params.indices = req.indices.join(',');
  }

  const response = await fetchBody({
    method: 'GET',
    url: '/catalog/search/suggestions',
    params,
    headers: {
      Accept: CollectionMediaTypeJSON,
      'Accept-Item': 'text/plain',
    },
  });
  const collection = response as Collection<string>;
  return collection;
};

// GetSearchFacets - gets all facets (for all indices) available for searching on within catalog
export const GetSearchFacets = async (): Promise<Collection<FacetRepr>> => {
  const response = await fetchBody({
    method: 'GET',
    url: '/catalog/search/facets',
    params: {
      [RequestParamStart]: 0,
      [RequestParamLimit]: 1000,
      includeHidden: 'true',
    },
    headers: {
      Accept: CollectionMediaTypeJSON,
      'Accept-Item': SearchFacetDefinitionJSON,
    },
  });

  const collection = response as Collection<FacetRepr>;
  return collection;
};
